import type { PropsWithChildren } from 'react';
import { Children } from 'react';
import '@/components/header/components/panel/panel.css';

export default function Panel(props: PropsWithChildren) {
  return (
    <div className='header-panel'>{Children.map(props.children, (child) => (child ? <div>{child}</div> : null))}</div>
  );
}
